import client from './httpClient'
import { USER_ENDPOINTS } from '../../constants/apiEndpoints'

export default {
  getUser(userId: string) {
    const emptyGuid = '00000000-0000-0000-0000-000000000000'

    return client.get(USER_ENDPOINTS.USER + userId + '/' + emptyGuid)
  },
  getUserByCognitoId(cognitoId: string) {
    const emptyGuid = '00000000-0000-0000-0000-000000000000'
    return client.get(USER_ENDPOINTS.USER + emptyGuid + '/' + cognitoId)
  },
  deleteUser(userId: string) {
    return client.delete(`/User?id=${userId}`)
  },
}
